<template>
	<v-dialog persistent width="auto" v-model="showDialog" v-if="selectedAllergy">
		<v-card style="min-height: 50vh; max-height: 80vh; width: 33vw; min-width: 400px" class="d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('allergy-details-header') }}</v-toolbar-title>
					</v-col>
					<v-spacer></v-spacer>
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 overflow-auto d-flex flex-column">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('allergen') }}:</div>
							<div class="text-body-1">{{ selectedAllergy.allergen }}</div>
						</v-col>
						<v-col cols="4" class="text-center">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('reaction') }}:</div>
							<div class="text-body-1">{{ selectedAllergy.reaction }}</div>
						</v-col>
						<v-col cols="4" class="text-right">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('severity') }}:</div>
							<div class="text-body-1">{{ selectedAllergy.severity }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('notes') }}:</div>
							<div class="text-body-1" style="white-space: pre-wrap">{{ selectedAllergy.notes }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col cols="8" class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('timestamp') }}:</span>
						<span class="text-body-1">
							{{ formatTimestamp(selectedAllergy.recordedAt, 'datetime_med') }}
						</span>
					</v-col>
					<v-col cols="4" class="text-right">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('By') }}:</span>
						<span class="text-body-1">{{ selectedAllergy.performedBy }}</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
export default {
	name: 'CCMAllergyViewDialog',

	props: ['showDialog', 'selectedAllergy'],

	methods: {
		formatTimestamp,
	},
};
</script>
